import tags from "../../../../components/tags";
import { icons, note } from "../../../../components/html";
import { statusCodes } from "../../../../components/responses";

export default {
  "/client/people/size-recommendation/{id}": {
    get: {
      tags: [tags.businessAccount],
      summary: "Size recommendation for connected user.",
      description: `${icons.c}
      Recommend size for connected user, which match the selected filtration.
      
${note(
  "For successful recommendation it is necessary for the client to have the chart added to its active one."
)}`,
      parameters: [
        { $ref: "#/components/parameters/acceptsLanguages" },
        { $ref: "#/components/parameters/tableId" },
        { $ref: "#/components/parameters/userEmailFilter" },
        { $ref: "#/components/parameters/gender" },
        { $ref: "#/components/parameters/limit" },
        { $ref: "#/components/parameters/offset" }
      ],

      responses: {
        "200": {
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  user: {
                    $ref: "#/components/schemas/user",
                    description: "Linked user for which size is recommended"
                  },
                  error: {
                    oneOf: [{ type: "object" }, { type: "false" }],
                    description: "There was an error while recommending",
                    example: "false"
                  },
                  size: {
                    $ref: "#/components/schemas/recommendedSize"
                  }
                }
              }
            }
          }
        },
        ...statusCodes
      }
    }
  }
};
